import TradingPlacesResponse from "entities/tradingPlacesResponse";
import TradingPlaceRepository from "../repositories/tradingPlaceRepository";
import { action, observable, runInAction } from "mobx";
import TradingPlaceDetailResponse from "entities/tradingPlaceDetailResponse";

export default class TradingPlaceService {
  @observable tradingPlaces: TradingPlacesResponse;
  @observable initialized = false;
  @observable tradingPlacesDetails: Map<string, TradingPlaceDetailResponse> = new Map();

  constructor(private repository: TradingPlaceRepository) {}

  @action.bound
  async initialize() {
    this.tradingPlaces = await this.repository.tradingPlaces();
    runInAction(() => (this.initialized = true));
  }

  async itemDetail(id: string) {
    if (!this.tradingPlacesDetails.has(id)) {
      const tradingPlace = await this.repository.getDetail(id);
      this.tradingPlacesDetails.set(id, tradingPlace);
    }

    return this.tradingPlacesDetails.get(id)!;
  }
}
